import { ExtraBidModalOptions } from 'Douleutaras/constants/ccf/need-help-options';
import { getAbsoluteUrl } from 'Douleutaras/utilities/url-builder';
import { NavigateFunction } from 'react-router/dist/lib/hooks';

interface RequestCcfExtraBidProps {
  jobId: string;
  bidsCount: number;
  optionSlug?: ExtraBidModalOptions;
  // tslint:disable:no-any
  eventValue?: any;
  navigate: NavigateFunction;
  // tslint:enable:no-any
  onOptionSelected?({ optionSlug }): Promise<void> | void;
  eventTracking?(eventName: string): void;
}

/**
 * Fires redux action to get an extra bid through CCF actions
 */
export const requestCcfExtraBid = async (
  { jobId,
    bidsCount,
    navigate,
    eventValue,
    eventTracking,
    onOptionSelected,
    optionSlug = ExtraBidModalOptions.I_NEED_AN_EXTRA_PRO
  }: RequestCcfExtraBidProps) => {
  if (typeof onOptionSelected === 'function') {
    await onOptionSelected({ optionSlug });
  }
  if (typeof eventTracking === 'function' && Boolean(eventValue)) {
    eventTracking(eventValue);
  }

  navigate({
    pathname: getAbsoluteUrl('CLIENT_DASHBOARD.PRO_LIST'),
    search: `?jobId=${jobId}`
  }, {
    state: {
      // We need original bids count to compare how many "autoDeals" jobs have and redirect user back in right time.
      bidsCount,
      fetchFreshList: true // This is a flag to for the react-router to always fetch a fresh list
    }
  });
};
